import { createSlice } from "@reduxjs/toolkit";
import { UserSlice } from "./user.types";
import { scopeSlice } from "services/store/scopeSlice";
import * as Sentry from "@sentry/browser";

const initialState:UserSlice = {
    user: null,
    permissions: [],
}

export const userSlice = createSlice({
    name: 'userSlice',
    initialState,
    reducers: {
        getUser: (state, action) => {

            const user = action.payload.data;
            const permissions = action.payload.data.permissions;

           

            if (!user) return {
                user: null,
                permissions: [],
            };
        
            const panelURL = `${import.meta.env.VITE_PANEL_URL}/nova/resources/users/${user.id}`

            Sentry.setUser({id: user.id, panelURL: panelURL})

            if (window.FreshworksWidget){

              const criticalEmail = action.payload.included?.find((d:any) => d._type === "user_emails" && d.type === "critical")?.email;
              const email = (() => {
                if (!user.email_change_required && user.email) return user.email;
                if (criticalEmail) return criticalEmail;
                return user.email;
              })()

                window.FreshworksWidget('prefill', 'ticketForm', {
                  name: action?.payload?.data?.first_name + " " + action?.payload?.data?.last_name,
                  email: email,
                  id: user.id,
                })
      
                window.FreshworksWidget('prefill', 'ticketForm', {
                  custom_fields: {
                    cf_user_id: user.id,
                    cf_panel_url: panelURL
                  }
                })
      
                // window.FreshworksWidget('hide', 'ticketForm', ['custom_fields.cf_user_id', 'custom_fields.cf_panel_url'], {
                // });
      
              } else {
                console.warn("FreshworksWidget not available")
              }

            state.user = user;
            if (permissions) state.permissions = permissions;

        },
        updateUserParams: (state, action) => {
          if (!state.user) return;
      
          const data = action.payload?.data;
          if (!data || typeof data !== 'object') {
              return;
          }
      
          Object.keys(data).forEach(param => {
              state.user[param] = data[param];
          });
      },
      updateStatus: (state, action) => {
        if (!state.user) return;
        state.user.onboarding_status = action.payload.data.onboarding_status;
      }, 
        clearUser: () => {
            return {
                user: null,
                permissions: [],
                access_tokens: [],
            };
        },
    },
    extraReducers: (builder) => {
      builder
      .addCase(scopeSlice.actions.logout, () => {
          return initialState;
      })
    }
});

export default userSlice;